import { Component } from '@angular/core';

@Component({
  selector: 'app-enroll-column-mapping',
  templateUrl: './enroll-column-mapping.component.html',
  styleUrls: ['./enroll-column-mapping.component.scss']
})
export class EnrollColumnMappingComponent {

}
